module.exports = __webpack_public_path__ + "static/img/cooler page top img_desktop.afd25f75.jpg";